module.exports = __webpack_public_path__ + "fonts/icomoon.4bfc0e18.ttf";